// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#app-bar[data-v-a7ab05ca]{flex:0;box-shadow:0 5px 5px -5px #c1c1c1!important;z-index:1}.logo[data-v-a7ab05ca]{background:url(https://comoquiero.net/logo.svg);background-size:contain;background-repeat:no-repeat;background-position:0 50%;width:160px;height:30px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
